export const initCountdowns = async () => {
    const lang = document.querySelector('html').getAttribute('lang')

    const getSeconds = date => {
        const difference = (date - new Date) / 1000

        return { seconds: difference }
    }

    const getHtml = (value, label, showDivider = true) => {
        let template = `<span class="is-value">${value}${label}</span>`

        if (showDivider === 'space') {
            template += `<span class="is-space"></span>`
        }
        else if (showDivider) {
            template += `<span class="is-divider">:</span>`
        }

        return template
    }

    const getString = async (timer) => {
        const { Countdown: locale } = await import(`Locale/${lang}.json`)

        const values = timer.getTimeValues(),
            days = values.days > 0 ? getHtml(values.days, locale.days) : '',
            hours = values.days > 0 || values.hours > 0 ? getHtml(values.hours, locale.hours) : '',
            minutes = values.days > 0 || values.hours > 0 || values.minutes > 0 ? getHtml(values.minutes, locale.minutes, 'space') : '',
            seconds = values.days > 0 || values.hours > 0 || values.seconds > 0 ? getHtml(values.seconds.toString().padStart(2, '0'), locale.seconds, false) : ''

        return `${days}${hours}${minutes}${seconds}`
    }

    for (const countdown of document.querySelectorAll('.js-countdown')) {
        if (countdown.classList.contains('is-countdown-initialized')) {
            continue
        }

        const { default: Timer } = await import(
            /* webpackChunkName: "easytimer" */
            'easytimer.js'
        )
        const date = new Date(countdown.dataset.time);
        const timer = new Timer({ countdown: true })

        timer.start({ startValues: getSeconds(date) })

        timer.addEventListener('secondsUpdated', async () => {
            countdown.innerHTML = await getString(timer)
        })

        timer.addEventListener('targetAchieved', () => {
            countdown.innerHTML = ''
        })

        countdown.classList.add('is-countdown-initialized')
    }
}
